import React from 'react';
import { safeHTML } from '../../../../utils/safeHTML';
import { useModal } from '../../../../hooks/useModal';
import { useTranslation } from '../../../../translations';
import numWord from '../../../../utils/numWord';

export default function SetsItem({ image, title, text, cash, modalType }) {
  const { addModal } = useModal();
  const { t } = useTranslation();

  const getVariants = (key) => [t(`${key}.text1`), t(`${key}.text2`), t(`${key}.text3`)];

  const titleVariantsByKey = {
    'setsContent.gradeData.0.cost.title': getVariants('other.beautyCostVariants'),
    'setsContent.gradeData.1.cost.title': getVariants('other.giftVariants'),
    'setsContent.gradeData.2.cost.title': getVariants('other.beautiesVariants'),
  };

  const titleValue = titleVariantsByKey[title]
    ? `${cash} ${numWord(cash, titleVariantsByKey[title])}`
    : t(title).replace('{count}', cash);

  function onClick() {
    if (!modalType) return;
    addModal({ type: modalType });
  }

  return (
    <div className={`sets__item`} onClick={onClick}>
      {image && (
        <div className={`sets__item-image`}>
          <img src={image} />
        </div>
      )}
      <div className={`sets__item-info`}>
        {title && <h4 className={'sets__item-title'}>{safeHTML(titleValue)}</h4>}
        {text && <p className={'sets__item-text'}>{safeHTML(t(text))}</p>}
      </div>
    </div>
  );
}
